import script from "./BlockChirp.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockChirp.vue?vue&type=script&setup=true&lang=js"

import "./BlockChirp.vue?vue&type=style&index=0&id=495f7b1f&lang=scss"

const __exports__ = script;

export default __exports__